"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var VipWheel_1 = __importDefault(require("./VipWheel"));
exports.default = VipWheel_1.default;
